"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_i18next_1 = require("react-i18next");
const core_1 = require("@material-ui/core");
const __1 = require("../..");
const styles_1 = __importDefault(require("./styles"));
const CallEndConfirmationModal = ({ loading = false, onCancel, onConfirm, open = false, }) => {
    const classes = styles_1.default();
    const hangupSVG = react_1.default.createElement(__1.HangupSVG, null);
    const { t: translate } = react_i18next_1.useTranslation();
    return (react_1.default.createElement(core_1.Dialog, { classes: {
            paper: classes.paper,
        }, open: open },
        react_1.default.createElement("div", { className: classes.dialogContainer },
            react_1.default.createElement(__1.Dialog, { header: {
                    logo: (react_1.default.createElement(__1.CompanyLogo, { className: classes.companyLogo, company: "his", reserveFill: true, scale: 2 })),
                }, body: {
                    className: classes.contentContainer,
                    children: (react_1.default.createElement(__1.ErrorMessage, { className: classes.errorMessageContainer, message: translate('common.errors.callEndConfirmation.confirmClose'), svg: hangupSVG })),
                }, buttons: {
                    children: (react_1.default.createElement("div", { className: classes.buttonsContainer },
                        react_1.default.createElement(__1.Button, { className: "confirmButton", id: "call-end-confirm", loading: loading, onClick: () => onConfirm() }, translate('common.buttons.endCall')),
                        react_1.default.createElement(__1.Button, { className: "cancelButton", id: "cancel-modal", onClick: () => onCancel() }, translate('common.buttons.cancel')))),
                } }))));
};
exports.default = CallEndConfirmationModal;
